<fc-general-modal
  [baseId]="baseId"
  [form]="form"
  [fcModalItemContext]="fcModalItemContext"
  (saveForm)="save()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form">
    <mat-tab-group
      animationDuration="0ms"
      mat-align-tabs="start"
      class="tabs-default full-modal-tabs"
      [disableRipple]="true"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Contact Info</span>
          <mat-badge
            *ngIf="getFormValidationErrors(contactInfoGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <div formGroupName="contactInfo">
          <!-- Corporation List -->
          <fc-corporation-list
            [baseId]="baseId"
            [form]="contactInfoGroup"
            [listItem]="listItemCorporation"
            [isSubmitted]="isSubmitted"
            [itemContext]="fcModalItemContext"
            [emailControlsEnabled]="false"
          ></fc-corporation-list>
          <!-- Corporation List -->

          <!-- Notes Control -->
          <div class="form-group full-control">
            <label
              for="{{ baseId }}-notes"
              translate
            >Notes</label>
            <textarea
              class="form-control"
              [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
              id="{{ baseId }}-notes"
              [maxlength]="fcListValidation.validations.Notes.MaxLength"
              formControlName="notes"
              rows="3"
            >
            </textarea>
            <div
              *ngIf="showErrors(notesControl, isSubmitted)"
              id="{{ baseId }}-warning-text-notes"
              class="incorrect-input"
              translate
            >
              {{ notesControl.errors | fcListValidation : 'Notes' }}
            </div>
          </div>
          <!-- Notes Control -->

          <!-- Inactive checkbox -->
          <div class="checkbox-group">
            <mat-checkbox
              id="{{ baseId }}-inactive-checkbox"
              formControlName="inactive"
              translate
            > Inactive
            </mat-checkbox>
          </div>
          <!-- Inactive checkbox -->
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Settings</span>
          <mat-badge
            *ngIf="getFormValidationErrors(settingsGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-settings-list
          [baseId]="baseId"
          [form]="settingsGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        ></fc-settings-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Claims</span>
          <mat-badge
            *ngIf="getFormValidationErrors(claimsGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <ap-fc-claims-list
          [baseId]="baseId"
          [form]="claimsGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        ></ap-fc-claims-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Labs/Providers</span>
          <mat-badge
            *ngIf="getFormValidationErrors(labsProvidersGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <ap-fc-labs-providers-list
          [baseId]="baseId"
          [form]="labsProvidersGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        ></ap-fc-labs-providers-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Procedure Mapping</span>
          <mat-badge
            *ngIf="getFormValidationErrors(procedureMappingGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-procedure-mapping-list
          [baseId]="baseId"
          [form]="procedureMappingGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        ></fc-procedure-mapping-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Payer ID Override</span>
          <mat-badge
            *ngIf="getFormValidationErrors(payerIdOverrideGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-payer-id-override-list
          [baseId]="baseId"
          [form]="payerIdOverrideGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        ></fc-payer-id-override-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-modal>